import { render } from "./SalesManagement.vue?vue&type=template&id=7730c6aa&scoped=true"
import script from "./SalesManagement.vue?vue&type=script&lang=js"
export * from "./SalesManagement.vue?vue&type=script&lang=js"

import "./SalesManagement.vue?vue&type=style&index=0&id=7730c6aa&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7730c6aa"]])

export default __exports__